import { useDispatch, useSelector } from "react-redux";
import { SBAComboBox } from "../UiComponents/SBADropDown";
import { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { getRoles, getSubMenusToRole, deleteSubMenuToRole, getAvailableSubMenus, insertUpdateSubMenuToRole} from "../../config/apiConfig";
import axios from "axios";
import { sbaAxios } from "../utils/sbaAxios";
import { useRef } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { SBAAGgrid } from '../UiComponents/SBAAGgrid';

export const SubMenuToRole = () => {
    const Gstate = useSelector((state) => state) || {};
    const [rolesData,setRolesData]=useState([]);
    const [selectedRole, setSelectedRole] = useState();
    const [subMenuList, setsubMenuList] = useState([]);
    const [showDrawer, setShowDrawer] = useState(false);
    const MenuRef = useRef();
    const [render, setRender] = useState(true);
    const [allMenuList, setallMenuList] = useState([]);
    const [selectroll, setselectroll] = useState([]);
    const ColumnFilteroption = false;

    useEffect(() => {
        rolesListData();
       
        if (selectedRole)
            getRolestouser();
        if (selectroll)
             menuList();
        
    }, [render]);
    const roleDDchn = (e) => {
        setSelectedRole(e.value);
        setselectroll(e.value.RoleId);
        menuListData(e.value.RoleId);
        sbaAxios({
            url:`${getSubMenusToRole}${e.value.RoleId}`,
            method: 'get',
        })
            .then(Response => { setsubMenuList(Response) }).catch(error => { console.log(error, 'error loadidng user list') });
    };
    const getRolestouser = () => {
        sbaAxios({
            url: `${getSubMenusToRole}${selectedRole.RoleId}`,
            method: 'get',
        }).then(Response => { setsubMenuList(Response) }).catch(error => { console.log(error, 'error loadidng user list') });
    }
    const rolesListData = async () => {
        try {

            const response = await  sbaAxios({
                url: `${getRoles}`,
                method: 'get',
            });
            const data = response;
            setRolesData(data);
        } catch (error) {
            console.error("Error fetching rolesListData from API:", error);
        }
    };
    const menuList = () => {
          sbaAxios({
            url: `${getSubMenusToRole},${selectroll}`,
            method: 'get',
        })
.then(Response => { setsubMenuList(Response) }).catch(error => { console.log(error, 'error loadidng user list') });
    }

    const menuListData = async (RoleId) => {
        try {
            const response = await  sbaAxios({
                url: `${getAvailableSubMenus}?roleId=${RoleId}`,
                method: 'get',
            });
            const data = response;
            setallMenuList(data.map(item => (
                { ...item, addMenu: false }
            )))
        } catch (error) {
            console.error("Error fetching MenuListData from API:", error);
        }
    };

    const CheckboxRenderer = (props) => {
        const isAddded = props.data.addMenu;
        const UserData = props.data;
        return (
            <div className="actions-cell">
                <input type='checkbox' className="SBA_hand" checked={isAddded} onChange={(e) => {
                    setallMenuList(value => (value.map(item => {
                        if (item.MenuId === UserData.MenuId) {
                            return { ...item, 'addMenu': e.target.checked }
                        }
                        else {
                            return { ...item }
                        }
                    }
                    )))
                }} />
            </div>
        );
    }
    const assignsubMenu = () => {
        let menuAssigned = true;
        if (MenuRef.current) {
            const gridInstance = MenuRef.current.api;
            const allRowData = [];

            gridInstance.forEachNode(node => {
                allRowData.push(node.data);
            });
            const filteredRow = (allRowData.filter(item => item.addMenu)).map(item => {
                console.log(item);
                return {
                    "RoleId": selectedRole.RoleId,
                    "RoleName": selectedRole.RoleName,
                    "MenuId": item.MenuId,
                    "MenuName": item.MenuName,
                    "UserId": selectedRole.UserId,
                    "UserName": selectedRole.UserName,
                    "CreatedBy": 38,
                    "ModifiedBy": 38,
                }
            });
            console.log(filteredRow, "i");
            filteredRow.map(item => {
                console.log(item, "it");
                sbaAxios({
                    url: `${insertUpdateSubMenuToRole}`,
                    method: 'post',
                    data: item,
                }).then(response => {
                    menuAssigned = true;
                })
            })
        };
        setShowDrawer(false);
        setRender(!render);
        if (menuAssigned) {
            toast.success("Sub Menu Assigned to Role", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
        setTimeout(() => {
            getRolestouser();
            menuListData(selectedRole.RoleId);
        }, 1000);
    }

    const handleDeleteClick = (MenuId, RoleId, Menuname) => {
        sbaAxios({
            url: `${deleteSubMenuToRole}${RoleId},${MenuId}`,
            method: 'get',
        }).then(() => {
            toast.success(`${Menuname} Deleted From the sub Menu`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
                getRolestouser();
                menuListData(selectedRole.RoleId);
        }).catch(() => {
            toast.error("Error Occured while Operation", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
            setTimeout(() => {
               
            }, 100);
        })
        setRender(!render);
    };
    const DeleteButtonRenderer = (props) => {
        const MenuId = props.data.MenuId;
        const RoleId = props.data.RoleId;
        const Menuname = props.data.MenuName;
            
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={() => handleDeleteClick(MenuId, RoleId, Menuname)}
                ></i>
            </div>
        );
    };
    const addsubmenuColDef = [
        {
            headerName: '',
            field: 'addMenu',
            cellRenderer: CheckboxRenderer,
            maxWidth: 80
        },
        {
            headerName: " Sub Menu Name", field: "MenuName", filter: "agTextColumnFilter"
        },
        {
            headerName: "Parent Menu", field: "ParentName"
        }
    ];
  
    const MenuGridDef = [
        {
         headerName: "Sub Menu Name", field: "MenuName" },
        { headerName: "Role Name", field: "RoleName" },
       
        {
            headerName: "Delete",
            field: "Delete",
            maxWidth: 100,
            cellRenderer: DeleteButtonRenderer,
        },
    ];
    const defaultColDef = {
        sortable: false,
        filter: false,
        suppressMovable: true,
        flex: 1,
        resizable:true
    };

    const AddMenu=()=>{
        setShowDrawer(true);
    }
    return <>
        <div className="col-lg-4 mt-4">
            <label
                htmlFor="select-fund"
                className="mb-1 ms-2 fw-semibold fs-12"
            >
                Select Role
            </label>
            <SBAComboBox data={rolesData} value={selectedRole} onChange={roleDDchn} textField='RoleName' valueField='RoleId' />
        </div>
        <div className="row flex-wrap mt-4">
            {selectedRole && <div className="col-lg-6">
                <div className="header-container m-2 fs-12">
                    <b>Available Menu in {selectedRole.RoleName}</b>
                    <button className="p-sm-btn mx-1" onClick={AddMenu}>
                        <i className="fa-solid fa-plus" /> Add
                    </button>
                </div>
                <div className="ag-theme-alpine m-1 " style={{ height: 450 }}>
                    {SBAAGgrid(MenuGridDef, subMenuList, ColumnFilteroption)}
                </div>
            </div>}
        </div>
        <SBADrawer
            open={showDrawer}
            setOpen={setShowDrawer}
            close={false}
            title={`Update Sub Menu for ${selectedRole?.RoleName}`}
            size={'lg'}
        >
            <div style={{ height: "80%" }}>
                <label className="header-container m-1">
                    <b>Sub Menu Name</b>
                </label>
                    <div className="ag-theme-alpine m-1 "  >
                    <AgGridReact
                        columnDefs={addsubmenuColDef}
                        rowData={allMenuList}
                        defaultColDef={defaultColDef}
                        ref={MenuRef}
                        suppressScrollOnNewData={true}
                    />
                           
                    </div>
                    <div className="mt-4">
                        <button className="s-sm-btn mx-1" onClick={() => setShowDrawer(false)}>
                            Cancel
                        </button>
                    <button className="p-sm-btn mx-1" onClick={assignsubMenu}>
                            Assign Sub Menu
                        </button>
                    </div>           
            </div>
        </SBADrawer>
        
    </>
}